React = require 'react'
MuteButton = require './MuteButton'
VideoBG = require './VideoBG-Drive-In'
#VideoBG = require './VideoBG'

Index = React.createClass
  getInitialState: ->
    muted: false

  onButtonChange: (newState) ->
    @setState checked: newState
    return

  onVideoChange: (newState) ->
   # @setState checked: newState
   return

  render: ->
    React.createElement("main", null,
      React.createElement("article", null,
        React.createElement("div", {"id": "hero"},
          React.createElement("div", {"id": "hero-content"},
            React.createElement("h2", {"className": "subheader"}, "flyingoctopus.net")
          ),
          React.createElement(MuteButton, {"id": "mute-button", "initialClicked": (@state.muted), "callbackParent": (@onButtonChange)}),
          React.createElement(VideoBG, {"initialChanged": (@state.muted), "callbackParent": (@onVideoChange)})
        )
      )
    )

module.exports = Index



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./app/components/Index.cjsx
 **/